import { docReady } from './utils';
import navbarInit from './bootstrap-navbar';
import detectorInit from './detector';

// /* -------------------------------------------------------------------------- */
// /*                            Theme Initialization                            */
// /* -------------------------------------------------------------------------- */

docReady(navbarInit);
docReady(detectorInit);

